export const questions: {
	[key: number]: {
		'question': string;
		'answers': string[];
		'correctAnswer': number
	}[]
} = {
	5: [
		{
			'question': 'چرا امام حسین (علیه‌السلام) مسلم بن عقیل را به کوفه فرستاد؟',
			'answers': ['برای جنگیدن با دشمنان', 'برای دعوت مردم کوفه به بیعت', 'برای جمع‌آوری کمک‌های مالی', 'برای مدیریت بازار کوفه'],
			'correctAnswer': 1
		},
		{
			'question': 'مهم‌ترین ویژگی مسلم بن عقیل که باعث شد امام به او اعتماد کند چه بود؟',
			'answers': ['دانش فقهی', 'شجاعت در میدان جنگ', 'وفاداری و دیانت', 'هنر خطابه'],
			'correctAnswer': 2
		},
		{
			'question': 'مسلم بن عقیل در کجا و چگونه به شهادت رسید؟',
			'answers': ['در کربلا با شمشیر', 'در مدینه با سم', 'در شام با شمشیر', 'در کوفه پس از خیانت مردم'],
			'correctAnswer': 3
		},
		{
			'question': 'مسلم بن عقیل پس از بیعت گسترده مردم کوفه، در کدام مکان ساکن شد؟',
			'answers': ['خانه هانی بن عروه', 'مسجد کوفه', 'قصر عبیدالله', 'بازار کوفه'],
			'correctAnswer': 0
		},
		{
			'question': 'پس از شهادت مسلم، امام حسین (علیه‌السلام) چه تصمیمی گرفت؟',
			'answers': ['حرکت به سمت شام', 'بازگشت به مدینه', 'ادامه مسیر به سوی کوفه', 'توقف در مکه'],
			'correctAnswer': 2
		}
	],
	6: [
		{
			'question': 'امام حسین (علیه‌السلام) در چه روزی به سرزمین کربلا رسید؟',
			'answers': ['دوم محرم', 'اول محرم', 'سوم محرم', 'دهم محرم'],
			'correctAnswer': 0
		},
		{
			'question': 'چرا امام حسین (علیه‌السلام) سرزمین کربلا را برای اقامت انتخاب کرد؟',
			'answers': ['آب فراوان داشت', 'دشمنان اجازه ندادند جای دیگری برود', 'چون از پیامبر شنیده بود محل شهادتش آنجاست', 'به خاطر کوه‌های محافظ اطرافش'],
			'correctAnswer': 2
		},
		{
			'question': 'اولین اقدام امام بعد از رسیدن به کربلا چه بود؟',
			'answers': ['حفر خندق', 'ساخت خیمه‌ها و آماده‌سازی خانواده‌ها', 'حمله به سپاه دشمن', 'نامه‌نگاری به یزید'],
			'correctAnswer': 1
		},
		{
			'question': 'امام حسین (علیه‌السلام) زمین کربلا را به چه کسی از بنی‌اسد خرید؟',
			'answers': ['زهیر بن قین', 'حربن یزید', 'قبیله بنی‌اسد', 'هیچ‌کس'],
			'correctAnswer': 2
		},
		{
			'question': 'چرا امام حسین (علیه‌السلام) زمین کربلا را خرید؟',
			'answers': ['برای ساخت مسجد', 'برای کشاورزی', 'برای اسکان دائمی خانواده', 'برای دفن شهدا در آن'],
			'correctAnswer': 0
		}
	],
	7: [
		{
			'question': 'فرزندان مسلم بن عقیل پس از شهادت پدرشان در کجا بودند؟',
			'answers': ['در کنار امام حسین', 'در کوفه زندانی بودند', 'در خانه‌ای مخفی شدند', 'به شام تبعید شدند'],
			'correctAnswer': 2
		},
		{
			'question': 'چرا حکمران کوفه دستور به قتل فرزندان مسلم داد؟',
			'answers': ['از شجاعت‌شان ترسید', 'از ترس حمایت مردم از آن‌ها', 'آن‌ها جاسوسی کرده بودند', 'چون پسران دشمن او بودند'],
			'correctAnswer': 1
		},
		{
			'question': 'یکی از مهم‌ترین درس‌هایی که از داستان فرزندان مسلم می‌گیریم چیست؟',
			'answers': ['وفاداری به اهل‌بیت حتی در کودکی', 'کودکان در جنگ نباید شرکت کنند', 'دوری از سفرهای خطرناک', 'پنهان‌کاری در زمان خطر'],
			'correctAnswer': 0
		},
		{
			'question': 'محمد و ابراهیم پس از اسارت، به کجا منتقل شدند؟',
			'answers': ['دارالاماره کوفه', 'زندان عمومی', 'خانه نگهبان زندان', 'منزل عبیدالله'],
			'correctAnswer': 2
		},
		{
			'question': 'کدام ویژگی این دو کودک بیشتر در تاریخ ثبت شده است؟',
			'answers': ['دانش علمی', 'سرعت در دویدن', 'زیارت اهل قبور', 'شجاعت و وفاداری در سن کم'],
			'correctAnswer': 3
		}
	],
	8: [
		{
			'question': 'چرا حر بن یزید ابتدا جلوی کاروان امام حسین (علیه‌السلام) را گرفت؟',
			'answers': ['مأمور حکومت یزید بود', 'با امام دشمنی شخصی داشت', 'قصد غارت کاروان را داشت', 'می‌خواست امام را به مدینه برگرداند'],
			'correctAnswer': 0
		},
		{
			'question': 'مهم‌ترین ویژگی حر که باعث شد در روز عاشورا توبه کند چه بود؟',
			'answers': ['شجاعت', 'وجدان بیدار و بصیرت در لحظه حساس', 'محاسبه سیاسی', 'حرف مردم کوفه'],
			'correctAnswer': 1
		},
		{
			'question': 'حر پس از پیوستن به امام حسین (علیه‌السلام) چه کرد؟',
			'answers': [
				'برای امام خطبه خواند',
				'فرار کرد',
				'تا پای جان جنگید و شهید شد',
				'خانواده‌اش را فرستاد و خودش برگشت'
			],
			'correctAnswer': 2
		},
		{
			'question': 'حر در کدام لحظه تصمیم گرفت از سپاه دشمن جدا شود؟',
			'answers': [
				'هنگام نماز ظهر عاشورا',
				'شب عاشورا',
				'هنگام برافراشته‌شدن پرچم دشمن',
				'صبح روز عاشورا، وقتی صدای گریه اهل حرم را شنید'
			],
			'correctAnswer': 3
		},
		{
			'question': 'امام حسین درباره حر پس از شهادتش چه فرمود؟',
			'answers': [
				'خدایش بیامرزد، که توبه‌اش پذیرفته شد',
				'تو آزادی، همان‌گونه که مادرت تو را آزاد نامید',
				'تو نگین توبه‌کنندگان هستی',
				'جزای نیکی‌ات را از خدا می‌گیرم'
			],
			'correctAnswer': 1
		}
	],
	9: [
		{
			'question': 'حضرت عبدالله بن حسن(علیه‌السلام) در روز عاشورا چند سال داشت؟',
			'answers': [
				'حدود ۷ سال',
				'۱۰ سال',
				'۱۳ سال',
				'۱۵ سال'
			],
			'correctAnswer': 1
		},
		{
			'question': 'چه زمانی حضرت عبدالله(علیه‌السلام) وارد میدان جنگ شد؟',
			'answers': [
				'آغاز نبرد',
				'هنگام تشنگی امام حسین(علیه‌السلام)',
				'زمانی که امام حسین(علیه‌السلام)در خطر بود',
				'بعد از شهادت حضرت عباس(علیه‌السلام)'
			],
			'correctAnswer': 2
		},
		{
			'question': 'مهم‌ترین پیام رفتاری حضرت عبدالله بن حسن(علیه‌السلام) چیست؟',
			'answers': [
				'حفظ ادب در میدان جنگ',
				'غیرت و دفاع از ولی خدا حتی با دست خالی',
				'اطاعت از عمویش',
				'اهمیت کودکان در جنگ‌ها'
			],
			'correctAnswer': 1
		},
		{
			'question': 'حضرت عبدالله‌بن‌حسن(علیه‌السلام) در روز عاشورا چگونه وارد میدان شد؟',
			'answers': [
				'با اجازه امام',
				'همراه برادرش قاسم',
				'ناگهان از خیمه بیرون دوید و خودش را به عمویش رساند',
				'همراه حضرت عباس(علیه‌السلام)'
			],
			'correctAnswer': 2
		},
		{
			'question': 'امام حسین (علیه‌السلام) پس از شهادت عبدالله چه واکنشی نشان داد؟',
			'answers': [
				'فریاد زد و شمشیر کشید',
				'از دشمن خواست به کودکان رحم کند',
				'بر سر دشمنان لعنت فرستاد',
				'او را در آغوش گرفت و با اشک گفت: «صبر کن عمو هم به تو ملحق خواهد شد»'
			],
			'correctAnswer': 3
		}
	],
	10: [
		{
			'question': 'قاسم فرزند کدام امام بود؟',
			'answers': [
				'امام حسین (علیه‌السلام)',
				'امام سجاد (علیه‌السلام)',
				'امام حسن (علیه‌السلام)',
				'امام باقر (علیه‌السلام)'
			],
			'correctAnswer': 2
		},
		{
			'question': 'پاسخ قاسم به امام حسین وقتی پرسید «مرگ در راه خدا چگونه است؟» چه بود؟',
			'answers': [
				'سخت و تلخ',
				'شیرین‌تر از عسل',
				'وظیفه دینی',
				'امتحان الهی'
			],
			'correctAnswer': 1
		},
		{
			'question': 'قاسم چگونه وارد میدان شد؟',
			'answers': [
				'با دستور پدر',
				'پس از اصرار و اجازه از امام حسین(علیه‌السلام)',
				'شبانه',
				'همراه با حضرت عباس(علیه‌السلام)'
			],
			'correctAnswer': 1
		},
		{
			'question': 'حضرت قاسم‌بن‌حسن(علیه‌السلام) هنگام رفتن به میدان جنگ چه درخواستی از امام داشت؟',
			'answers': [
				'دعا برای شهادت',
				'گرفتن شمشیر مخصوص',
				'اجازه رسمی از عمویش',
				'خداحافظی با مادر'
			],
			'correctAnswer': 2
		},
		{
			'question': 'پیکر قاسم چگونه به سوی خیمه‌ها بازگشت؟',
			'answers': [
				'توسط یاران بازگردانده شد',
				'در میدان باقی ماند',
				'امام حسین با سختی از میدان جمع‌آوری کرد',
				'دشمن آن را تحویل نداد'
			],
			'correctAnswer': 2
		}
	],
	11: [
		{
			'question': 'حضرت علی‌اکبر(علیه‌السلام) در چه چیزی شبیه پیامبر بود؟',
			'answers': [
				'شمشیرزنی',
				'چهره و صدای او',
				'رفتار سیاسی',
				'خطابه‌خوانی'
			],
			'correctAnswer': 1
		},
		{
			'question': 'امام حسین(علیه‌السلام) هنگام رفتن حضرت علی‌اکبر(علیه‌السلام) به میدان چه فرمود؟',
			'answers': [
				'پسرم برگرد',
				'تو تنها امید منی',
				'ای کاش خودم می‌رفتم',
				'اللهم اشهد علی هؤلاء القوم'
			],
			'correctAnswer': 3
		},
		{
			'question': 'مهم‌ترین ویژگی حضرت علی‌اکبر(علیه‌السلام) در سیره او چیست؟',
			'answers': [
				'شهامت',
				'ادب و شباهت به پیامبر(صلی‌الله‌علیه‌و‌اله‌و‌سلم) در اخلاق',
				'تجربه نظامی',
				'مقام علمی'
			],
			'correctAnswer': 1
		},
		{
			'question': 'چه زمانی حضرت علی‌اکبر(علیه‌السلام) برای میدان رفتن اجازه خواست؟',
			'answers': [
				'وقتی یاران امام یکی‌یکی شهید شدند',
				'پس از تشنگی شدید کاروان',
				'بعد از نماز ظهر عاشورا',
				'بعد از شهادت حضرت قاسم(علیه‌السلام)'
			],
			'correctAnswer': 0
		},
		{
			'question': 'امام حسین(علیه‌السلام) هنگام شهادت حضرت علی‌اکبر(علیه‌السلام) چه فرمود؟',
			'answers': [
				'خدایا بر من صبر نازل کن',
				'خدایا، تو شاهد باش که جوانی چون علی‌اکبر به میدان فرستادم',
				'پسرم، دنیا بعد از تو تاریک است',
				'تو فدای دین شدی'
			],
			'correctAnswer': 2
		}
	],
	12: [
		{
			'question': 'حضرت علی‌اصغر(علیه‌السلام) هنگام شهادت چند ماهه بود؟',
			'answers': [
				'۳ ماه',
				'۶ ماه',
				'یک سال',
				'دو سال'
			],
			'correctAnswer': 1
		},
		{
			'question': 'امام حسین (علیه‌السلام)، حضرت علی‌اصغر(علیه‌السلام) را چگونه به میدان آورد؟',
			'answers': [
				'برای طلب آب از دشمن',
				'برای خداحافظی',
				'برای برکت در کارزار',
				'برای درمان'
			],
			'correctAnswer': 0
		},
		{
			'question': 'دشمن چگونه با حضرت علی‌اصغر(علیه‌السلام) رفتار کرد؟',
			'answers': [
				'به او آب داد',
				'او را اسیر کرد',
				'با تیر سه‌شعبه به گلویش زد',
				'فراری‌اش داد'
			],
			'correctAnswer': 2
		},
		{
			'question': 'چه کسی تیر سه‌شعبه را به گلوی حضرت علی‌اصغر(علیه‌السلام) زد؟',
			'answers': [
				'عمر بن سعد',
				'شمر بن ذی‌الجوشن',
				'حرمله بن کاهل',
				'سنان بن انس'
			],
			'correctAnswer': 2
		},
		{
			'question': 'امام حسین(علیه‌السلام) پس از شهادت حضرت علی‌اصغر(علیه‌السلام)، پیکرش را کجا برد؟',
			'answers': [
				'در کنار پیکر حضرت علی‌اکبر(علیه‌السلام)',
				'به پشت خیمه‌ها و در خاک پنهان کرد',
				'به خیمه مادرش',
				'بر دستان حضرت زینب(سلام‌الله‌علیه)'
			],
			'correctAnswer': 1
		}
	],
	13: [
		{
			'question': 'حضرت عباس (علیه‌السلام) در کربلا چه نقشی داشت؟',
			'answers': [
				'تنها نگهبان خیمه‌ها',
				'سخن‌گوی کاروان',
				'پرچم‌دار سپاه امام حسین(علیه‌السلام) و محافظ اهل بیت',
				'معلم کودکان در خیمه'
			],
			'correctAnswer': 2
		},
		{
			'question': 'چرا حضرت عباس(علیه‌السلام) با اینکه توانست آب بیاورد، خود آب ننوشید؟',
			'answers': [
				'به دلیل ترس از دشمن',
				'فراموش کرد',
				'وفاداری به امام و تشنگی اهل بیت',
				'آب را گم کرد'
			],
			'correctAnswer': 2
		},
		{
			'question': 'کدام ویژگی برجسته حضرت عباس(علیه‌السلام) در زیارتنامه‌اش آمده است؟',
			'answers': [
				'علم و فقه',
				'بصیرت و وفاداری',
				'زهد و تقوا',
				'خوش‌خطی و کتابت'
			],
			'correctAnswer': 1
		},
		{
			'question': 'چرا حضرت عباس (علیه‌السلام) دست‌هایش را از دست داد؟',
			'answers': [
				'دشمن او را از پشت گرفت',
				'به‌دلیل سنگینی مشک',
				'هنگام دفاع از مشک و تلاش برای بازگشت',
				'از قبل مجروح بود'
			],
			'correctAnswer': 2
		},
		{
			'question': 'لقب معروف حضرت عباس(علیه‌السلام) چیست؟',
			'answers': [
				'سیدالشهدا',
				'سقای عطشانان',
				'علمدار کربلا',
				'شهید عاشورا'
			],
			'correctAnswer': 2
		}
	],
	14: [
		{
			'question': 'انگیزه اصلی امام حسین (علیه‌السلام) از قیام عاشورا چه بود؟',
			'answers': [
				'رسیدن به حکومت',
				'گرفتن انتقام از بنی‌امیه',
				'اصلاح امت و زنده‌کردن امر به معروف و نهی از منکر',
				'مهاجرت به مدینه'
			],
			'correctAnswer': 2
		},
		{
			'question': 'آخرین سخن امام حسین (علیه‌السلام) با دشمنان در میدان چه بود؟',
			'answers': [
				'«آیا کسی هست مرا یاری کند؟ «',
				'«به خدا سوگند، من بر باطل نیستم «',
				'«ما از خاندان پیامبریم، ما را بگذارید «',
				'«اگر دین ندارید، آزاده باشید «'
			],
			'correctAnswer': 3
		},
		{
			'question': 'پیام جهانی عاشورا برای مردم همه زمان‌ها چیست؟',
			'answers': [
				'سازش‌ناپذیری با ظلم و دفاع از حق، حتی با فداکردن جان',
				'شجاعت بی‌مهابا',
				'قهرمان‌پروری',
				'مدیریت جنگ و صلح'
			],
			'correctAnswer': 0
		},
		{
			'question': 'آخرین کلمات امام حسین (علیه‌السلام) هنگام شهادت چه بود؟',
			'answers': [
				'«هل من ناصر... «',
				'«رضاً برضائک، تسلیماً لأمرک «',
				'«خدایا، تو را شکر می‌کنم «',
				'«زینبم را تنها مگذار «'
			],
			'correctAnswer': 1
		},
		{
			'question': 'پیکر امام حسین (علیه‌السلام) پس از شهادت چه شد؟',
			'answers': [
				'با احترام دفن شد',
				'سالم باقی ماند',
				'زیر سم اسبان دشمن قرار گرفت و قطعه‌قطعه شد',
				'دشمن از آن محافظت کرد'
			],
			'correctAnswer': 2
		}
	]
};
export const days: {
	[key: number]: {
		'title': string;
		'subject': string;
		'description': string;
	}
} = {
	5: {
		'title': 'روز اول محرم – مسلم بن عقیل',
		'subject': 'سفیر وفادار و مظلوم امام حسین (علیه‌السلام)',
		'description': 'مسلم، پسر عقیل و برادرزاده‌ی امیرالمؤمنین بود؛ مردی پاک‌دل، شجاع و باایمان. امام حسین (علیه‌السلام) او را برای سنجش وفاداری مردم کوفه به آن‌جا فرستاد. ابتدا هزاران نفر با او بیعت کردند، اما با تهدید عبیدالله بن زیاد، همه جز اندکی، او را تنها گذاشتند. مسلم با دلی شکسته، پس از نماز مغرب، دستگیر شد و همان شب، مظلومانه از بالای قصر کوفه به زمین افکنده شد. غربتش آغاز غربت عاشورا بود...'
	},
	6: {
		'title': 'روز دوم محرم – ورود امام حسین (علیه‌السلام) به کربلا',
		'subject': 'پای نهادن کاروان حق بر خاک مقدس',
		'description': 'در دوم محرم سال ۶۱ هجری، کاروان کوچک امام حسین به سرزمین کربلا رسید. اسب امام ناگهان ایستاد و نرفت. وقتی پرسیدند چرا، فرمود: «اینجا وعده‌گاه خون ماست». با ایمان و آرامش، خیمه‌ها را برپا کرد و خاک را بویید. آری، اینجا خاک قربانگاه عشق بود، جایی که آسمان هم به خون نشست.'
	},
	7: {
		'title': 'روز سوم محرم – فرزندان مسلم (محمد و ابراهیم)',
		'subject': 'کودکانی در اوج وفاداری',
		'description': 'محمد و ابراهیم، دو کودک غیور مسلم، پس از شهادت پدر، آواره شدند. زن نیک‌سرشتی آن‌ها را پنهان کرد؛ اما شبانه به دست پاداش‌طلبان افتادند. دشمن که حتی به لب‌های خشک کودکان هم رحم نکرد، آن دو نور کوچک را کنار شط فرات با دستان بسته، به شهادت رساند. گویی کربلا تنها محدود به دشت نبود، کوفه نیز صحنه مظلومیت بود...'
	},
	8: {
		'title': 'روز چهارم محرم – حر بن یزید ریاحی',
		'subject': 'تولد دوباره یک دل‌آگاه',
		'description': 'حر، سردار رشید کوفه بود که ابتدا راه را بر امام بست. اما تردید و اشک، کم‌کم دلش را بیدار کرد. در صبح عاشورا، تصمیمی سخت گرفت؛ زنجیر منصب و دنیا را شکست، بر اسب نشست و با چشمی اشک‌بار به سمت حسین آمد. امام با آغوش باز پذیرایش شد. حر در میدان جنگ جان داد؛ با پیشانی شکافته، اما دلی آرام. این است قدرت توبه...'
	},
	9: {
		'title': 'روز پنجم محرم – حضرت عبدالله بن حسن(علیه‌السلام)',
		'subject': 'کودکی که جانش را سپر امام کرد',
		'description': 'عبدالله نوجوانی ۱۰ ساله بود. وقتی دید عمویش امام حسین در میان دشمنان تنها مانده، بی‌درنگ دوید و با دستان کوچکش شمشیر دشمن را دفع کرد. ضربه‌ای بر سرش فرود آمد، بر زمین افتاد و در آغوش حسین جان داد. او نشان داد که سن، مانع غیرت و ولایت‌مداری نیست...'
	},
	10: {
		'title': 'روز ششم محرم – حضرت قاسم بن حسن (علیه‌السلام)',
		'subject': 'جوان‌ترین داماد کربلا',
		'description': 'قاسم، نوجوانی خوش‌سیما و شجاع، فرزند امام حسن(علیه‌السلام) بود. وقتی اجازه میدان خواست، امام حسین(علیه‌السلام) پرسید: مرگ در نظرت چگونه است؟ گفت: «شیرین‌تر از عسل». در میدان چون شیر جنگید تا آنکه زیر سم اسبان، پیکر جوانش به آسمان پرواز کرد. آری، قاسم به‌جای حجله، به خون نشست؛ و به دامادی شهادت رفت...'
	},
  11: {
		'title': 'روز هفتم محرم – حضرت علی‌اکبر (علیه‌السلام)',
		'subject': 'شبیه‌ترین فرد به پیامبر (صلی‌الله‌علیه‌و‌اله‌و‌سلم)',
		'description': 'علی‌اکبر، جوان رشید و باوقار امام حسین(علیه‌السلام) بود. در ادب، چهره، صدا و اخلاق، چون پیامبر بود. اولین شهید بنی‌هاشم در روز عاشورا بود. در میدان نبرد، آن‌قدر مردانه جنگید که دشمن گفت: «به خدا قسم، این جوان شباهتی به پیامبر دارد که ما را خجالت‌زده می‌کند.» وقتی شهید شد، امام فرمود: «پسرم، دنیا بعد از تو تاریک است... «'
	},
	12: {
		'title': 'روز هشتم محرم – حضرت علی‌اصغر(علیه‌السلام)',
		'subject': 'نوزادی که زبان کربلا شد',
		'description': 'در میان عطش و محاصره، امام حسین(علیه‌السلام) نوزادش را بر بلندای دست گرفت و گفت: «اگر به من رحم نمی‌کنید، به این شیرخوار آب دهید.» پاسخش، تیر سه‌شعبه‌ای بود که گلوی نوزاد را شکافت. علی‌اصغر، بی‌کلام‌ترین شهید عاشورا، اما رساترین زبان مظلومیت شد.'
	},
	13: {
		'title': 'روز نهم محرم – حضرت عباس (علیه‌السلام)',
		'subject': 'عباس؛ ترجمه عینی وفاداری',
		'description': 'ابوالفضل، برادر وفادار حسین، علمدار کربلا و امید کودکان تشنه بود. وقتی برای آوردن آب رفت، مشک را پر کرد، اما لب به آب نزد. در بازگشت، دستانش را بریدند، مشک را نشانه گرفتند، و قلب خیمه‌ها شکست. امام بر بالینش گفت: «کمرم شکست، ای علمدار من... «'
	},
	14: {
		'title': 'روز دهم محرم – امام حسین (علیه‌السلام) و شهدای عاشورا',
		'subject': 'قله عاشقی و ایثار',
		'description': 'در ظهر عاشورا، یاران همه رفته بودند؛ کودکان از تشنگی می‌سوختند، و امام تنها مانده بود. یک‌تنه در میدان، تا آخرین لحظه ایستاد؛ نه برای قدرت، بلکه برای عزت. پیکر پاره‌پاره‌اش بر خاک افتاد و آسمان، شرمنده بارید. او رفت تا بماند، رفت تا وجدان تاریخ را بیدار کند.'
	}
};
export const dayKeys = [5, 6, 7, 8, 9, 10,11, 12, 13, 14];
